import * as React from "react";
import { FunctionComponent } from "react";
import { Redirect, Route } from "react-router-dom";

import { LOGIN_ROUTE } from "./Routes";
import { RepositoryKey, setObject } from "utils/repository";

export const SecuredRoute = (props: {
    component: FunctionComponent;
    authenticated: boolean;
    secured: boolean;
    path: string;
    key: number;
}): React.JSX.Element => {
    return (
        <Route
            exact={true}
            path={props.path}
            key={props.key}
            render={({ location }) => {
                if (props.authenticated || !props.secured) {
                    return <>{React.createElement(props.component)}</>;
                }
                setObject(RepositoryKey.LOGIN_RETURN_TO, location.pathname + location.search);
                return (
                    <Redirect
                        to={{
                            pathname: LOGIN_ROUTE.path,
                        }}
                    />
                );
            }}
        />
    );
};
